import React, { Component } from "react";
import Slider from "react-slick";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { AiOutlinePause } from "react-icons/ai";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./DefaultFooter.scss";
import stl from "./DefaultFooter.module.scss";
class DefaultFooter extends Component {
	state = {
		autoPlay: true,
	};

	next = () => {
		this.slider.slickNext();
	};

	previous = () => {
		this.slider.slickPrev();
	};

	pause = () => {
		this.setState({
			autoPlay: !this.state.autoPlay,
		});
	};

	selectChange = (e) => {
		if (e.target.value !== "관련 홈페이지") window.open(e.target.value, "");
	};

	render() {
		const settings = {
			infinite: true,
			autoplay: this.state.autoPlay,
			autoplaySpeed: 6000,
			speed: 2000,
			slidesToShow: 5,
			slidesToScroll: 1,
			pauseOnHover: true,
			variableWidth: true,
			responsive: [
				{
					// 1206px 이하: 한 줄에 3개
					breakpoint: 1207,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						variableWidth: false,
					},
				},
				{
					// 1024px 이하: 한 줄에 3개
					breakpoint: 1025,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						variableWidth: false,
					},
				},
				{
					// 600px 이하: 한 줄에 2개
					breakpoint: 601,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						variableWidth: false,
					},
				},
				{
					// 420px 이하: 한 줄에 1개
					breakpoint: 421,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						variableWidth: false,
					},
				},
			],
		};

		return (
			<>
				<div id={stl.siteWrapper}>
					<div className={stl.container}>
						<div className={stl.leftBanner}>배너모음</div>
						<div className={stl.rightBanner}>
							<div className={stl.bannerWrapper}>
								<div className={`${stl.button} ${stl.prev}`} onClick={this.previous}>
									{/*<GrFormPrevious />*/}
								</div>
								<div className={stl.bannerList}>
									<Slider {...settings} ref={(c) => (this.slider = c)}>
										<a className={`${stl.bannerItem} ${stl.item1}`} href="https://jeonnam-gwangju.go.kr/" target="_blank" rel="noopener noreferrer" style={{width: 200}}>전남광주통합특별시</a>
										<a className={`${stl.bannerItem} ${stl.item2}`} href="https://map.jeonnam-gwangju.go.kr/main" target="_blank" rel="noopener noreferrer" style={{width: 164}}>공간정보참여마당</a>
										<a className={`${stl.bannerItem} ${stl.item2}`} href="https://tour.jeonnam-gwangju.go.kr" target="_blank" rel="noopener noreferrer" style={{width: 164}}>비짓전남광주</a>
										<a className={`${stl.bannerItem} ${stl.item5}`} href="https://bigdata.jeonnam-gwangju.go.kr/tour/index.html#/tour/mapservice?1" target="_blank" rel="noopener noreferrer" style={{width: 200}}>관광빅데이터분석</a>
										<a className={`${stl.bannerItem} ${stl.item3}`} href="https://seereal.lh.or.kr/main.do" target="_blank" rel="noopener noreferrer" style={{width: 160}}>SEE:REAL</a>
										{/*<a className={`${stl.bannerItem} ${stl.item4}`} href="http://hevi.gwangju.go.kr/home/pj/hevi/SkyList.do?menuId=hevi0208000000" target="_blank" rel="noopener noreferrer" style={{width: 240}}>광주광역시보건환경연구원<span>&#47;</span></a>*/}
										
										<a className={`${stl.bannerItem} ${stl.item6}`} href="https://map.vworld.kr/map/maps.do" target="_blank" rel="noopener noreferrer" style={{width: 200}}>3차원지도</a>
										{/*<a className={`${stl.bannerItem} ${stl.item7}`} href="http://klis.gwangju.go.kr/sis/main.do" target="_blank" rel="noopener noreferrer" style={{width: 236}}>한국토지정보시스템 KLIS<span>&#47;</span></a>*/}
									</Slider>
								</div>
								<div className={`${stl.button} ${stl.next}`} onClick={this.next}>
									{/*<GrFormNext />*/}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div id={stl.defaultFooter}>
					<div className={stl.footerWrapper}>
						<div className={`${stl.foot} ${stl.left}`}>
							{/* <div className={stl.top}> */}
							{/* <span className={`${stl.link} ${stl.frst}`}>
                                    <label>개인정보처리방침</label>
                                </span>
                                <span className={`${stl.link} ${stl.last}`}>
                                    <label>관리자 문의 메일</label>
                                </span>
                                <span className={`${stl.link} ${stl.last}`}>
                                    <label>찾아오시는길</label>
                                </span> */}
							{/* </div> */}
							<div className={stl.bot}>
								<div className={stl.logo}></div>
							</div>
						</div>
						<div className={`${stl.foot} ${stl.right}`}>
							<span>[58654] 전남광주통합특별시 무안군 삼향읍 오룡길 1 TEL : 061)286-7646 전남광주통합특별시 토지관리과 | [61945] 전남광주통합특별시 서구 내방로 111(치평동) TEL : 062)613-4586<br/><br/>
								본 페이지에 게시된 메일 주소가 자동으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 처벌됨을 유념하시기 바랍니다.<br/><br/>
								Copyright © 2025 Jeonnam-Gwangju Special Metropolitan City. All Rights Reserved.
							</span>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default DefaultFooter;
